import useSeo from "@/lib/useSeo";
import LegalPage from "@/components/marketing/LegalPage";
import { PRIVACY, PRIVACY_META } from "@/content/privacy";

export default function Privacy() {
  useSeo({ title: "Privacy Policy", description: "How ChangeOS collects, uses and protects personal data, including AI processing, bring-your-own-key and data export.", path: "/privacy" });
  return <LegalPage meta={PRIVACY_META} sections={PRIVACY} testid="privacy-page" contactIntro="For privacy questions, access or correction requests, or complaints, please contact us at:" />;
}
